import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {FreeRoundsScreenView} from '@fantasmagames/slot/src/modules/microgaming/freerounds/FreeRoundsScreenView';
import {FreeRoundsScreenModule} from '@fantasmagames/slot/src/modules/microgaming/freerounds/FreeRoundsScreenModule';
import {FreeRoundsScreenEvents} from '@fantasmagames/slot/src/modules/microgaming/freerounds/FreeRoundsScreenEvents';

export class FreeRoundsInGameState extends ModuleState<FreeRoundsScreenView, FreeRoundsScreenModule> {
	public onEnterState(): void {
	}

	public onLeaveState(): void {
	}

	protected setupEvents(): void {
		this.on(FreeRoundsScreenView.KEEP_IT_PRESSED, this.onKeepItPressed);
	}

	protected onKeepItPressed(): void {
		this.emit(FreeRoundsScreenEvents.RESTORE_TO_IN_GAME);
	}

}


// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/microgaming/freerounds/states/FreeRoundsInGameState.ts